export default __webpack_public_path__ + "static/logo-bff24ac592d29dc3be62a8daa14a1e3e.png";